import WebView from 'react-native-webview';
import {useSelector} from 'react-redux';
import {useWindowDimensions, ScrollView, StyleSheet, View} from 'react-native';
import {MenuNavigation} from 'interface/stacks/MenuNavigation';
import {MenuAccount} from 'interface/stacks/MenuAccount';
import {MenuStorage} from 'interface/stacks/MenuStorage';
import {MenuLinks} from 'interface/stacks/MenuLinks';
import {getHost, isIOS, isNative, isSafari} from 'utils/platform';
import {colors, breakpoints} from 'config/styles';
import {theme} from 'config/themes';

import * as app from 'store/slices/app';

export function Menu() {
  const host = getHost();
  const screen = useWindowDimensions();
  const isBusiness = useSelector(app.selectors.isBusiness);
  const isPromoDisabled = isIOS() || isSafari();
  const hasFloatingMenu = screen.width <= breakpoints.menu;
  const hasSidebarPromo = !isPromoDisabled && !isBusiness && !isNative();
  const classes = {
    root: [
      styles.root,
      hasFloatingMenu && styles.floating,
    ],
  };

  return (
    <ScrollView
      style={classes.root}
      contentContainerStyle={styles.inner}
      showsVerticalScrollIndicator={false}
      accessibilityLabel="Main Menu">
      <View style={styles.content}>
        <View>
          <MenuAccount/>
          <View style={styles.divider}></View>
          <MenuNavigation/>
          <View style={styles.divider}></View>
          <MenuLinks/>
        </View>
        <View>
          {hasSidebarPromo &&
            <View style={styles.promo}>
              <WebView source={{uri: `${host}/widgets/sidebar_promo.php`}}/>
            </View>
          }
          <MenuStorage/>
        </View>
      </View>
    </ScrollView>
  );
}

export const styles = StyleSheet.create({
  root: {
    height: '100%',
    width: 200,
    borderRightWidth: 1,
    borderColor: theme.app.menu,
    backgroundColor: colors.neutral.dark,
  },
  inner: {
    flexGrow: 1,
  },
  content: {
    flex: 1,
    justifyContent: 'space-between',
  },
  floating: {
    borderRightWidth: 0,
  },
  divider: {
    height: 2,
    width: 168,
    marginVertical: 8,
    marginHorizontal: 16,
    backgroundColor: '#3d4350',
    overflow: 'visible',
  },
  promo: {
    width: 200,
    height: 306,
    marginVertical: 16,
  },
  fill: {
    flex: 1,
  },
});
